// User roles:
export const ADMIN = 'admin'
export const LEARNING_MANAGER = 'learning_manager'
export const LOCAL_SUPER_USER = 'local_superuser'
export const MANAGER = 'manager'
export const SUPER_ADMIN = 'superadmin'
export const SUPER_USER = 'superuser'
export const TESTER = 'tester'

// Groups:
export const GROUP_TYPES = {
  POSITION: 'position',
  DEPARTMENT: 'department',
  CUSTOM_GROUP: 'default',
  LEADERBOARD: 'leaderboard',
}

// Product sorts
export const PRODUCTS_LIST_SORT_KEYS = [
  'created_at',
  'title',
  'description_long',
]

// Product sorts
export const CERTIFICATES_LIST_SORT_KEYS = ['created_at']

// Link targets:
export const LINK_TARGET_DEFAULT = '_self'
export const LINK_TARGET_NEW_TAB = '_blank'

// File size limiters:
export const MAX_SIZE_IMG = 5000
export const MAX_SIZE_APNG = 30000
export const MAX_SIZE_FILE = 30000

// Engage layout
export const MAX_JOURNEY_PRODUCTS = 23 // 20 journey products + 3 checkpoints
export const MAX_CHECKPOINT_PRODUCTS = 3 // Checkpoint Island holds at most 3 products (enforced by the backend)

// localStorage
export const LOCAL_STORAGE_KEY_PRODUCT_FILTERS = 'attensi_admin:product_filters'
export const LOCAL_STORAGE_KEY_EVENTS_FILTERS = 'attensi_admin:events_filters'
export const LOCAL_STORAGE_KEY_PORTAL_LAYOUT_FILTERS =
  'attensi_admin:portal_layout_filters'
export const LOCAL_STORAGE_KEY_USER_FILTERS = 'attensi_admin:user_filters'
export const LOCAL_STORAGE_KEY_POLICY_FILTERS = 'attensi_admin:policy_filters'

// Various
export const HELP_URL = 'https://help.attensi.com'
